import React from 'react';
import {
  Chip,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import {
  REGISTER_TOGGLE_ALL,
  REGISTER_TOGGLE_GROUP_ALL,
  REGISTER_TOGGLE_GROUP_SELECT,
} from '../../common/consts';

const CalendarTargetToggleGroup = ({
  name,
  value,
  list,
  onChange,
  onItemChange,
  disabled,
}) => {
  return (
    <Stack gap={1} sx={{ pr: 1, width: { sm: '100%', md: '50%' } }}>
      <Typography variant="body2">일정 등록할 로봇 선택</Typography>
      <ToggleButtonGroup
        color="secondary"
        name={name}
        value={value}
        exclusive
        onChange={onChange}
        disabled={disabled}
        sx={{ width: '100%', '& button': { width: '100%' } }}
      >
        {[
          { label: '모든 로봇', value: REGISTER_TOGGLE_ALL },
          { label: '모든 그룹', value: REGISTER_TOGGLE_GROUP_ALL },
          { label: '그룹 선택', value: REGISTER_TOGGLE_GROUP_SELECT },
        ].map(({ label: l, value: v }) => (
          <ToggleButton name={name} value={v} key={v}>
            {l}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {value === REGISTER_TOGGLE_GROUP_SELECT && list.length > 0 && (
        <Stack direction="row" gap={1}>
          {list.map(({ name: groupName, id: groupId }) => (
            <Chip
              key={groupId}
              label={groupName}
              color="secondary"
              variant="outlined"
              onDelete={disabled ? null : onItemChange(groupId)}
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
};

export default CalendarTargetToggleGroup;
